export var selectMessages = function selectMessages(rootState) {
  return rootState.aiChatApp.messages;
};
export var selectCurrentConversationId = function selectCurrentConversationId(rootState) {
  return rootState.aiChatApp.currentConversationId;
};
export var selectGetConversationsWithMessagesStatus = function selectGetConversationsWithMessagesStatus(rootState) {
  return rootState.aiChatApp.getConversationsWithMessagesStatus;
};
export var selectGetMessagesStatus = function selectGetMessagesStatus(rootState) {
  return rootState.aiChatApp.getMessagesStatus;
};
export var selectMessagesNextToken = function selectMessagesNextToken(rootState) {
  return rootState.aiChatApp.messagesNextToken;
};
export var selectIsStreaming = function selectIsStreaming(rootState) {
  return rootState.aiChatApp.isStreaming;
};
export var selectStreamingContent = function selectStreamingContent(rootState) {
  return rootState.aiChatApp.streamingContent;
};
export var selectError = function selectError(rootState) {
  return rootState.aiChatApp.error;
};
export var selectSendMessageOutput = function selectSendMessageOutput(rootState) {
  return rootState.aiChatApp.sendMessageOutput;
};
export var selectSendMessageStatus = function selectSendMessageStatus(rootState) {
  return rootState.aiChatApp.sendMessageStatus;
};
export var selectStreamingMessageId = function selectStreamingMessageId(rootState) {
  return rootState.aiChatApp.streamingMessageId;
};
export var selectCurrentMessageId = function selectCurrentMessageId(rootState) {
  return rootState.aiChatApp.currentMessageId;
};
export var selectStopMessageStatus = function selectStopMessageStatus(rootState) {
  return rootState.aiChatApp.stopMessageStatus;
};
export var selectAttachments = function selectAttachments(rootState) {
  return rootState.aiChatApp.attachments;
};
export var selectCreateAiAttachmentFilesStatus = function selectCreateAiAttachmentFilesStatus(rootState) {
  return rootState.aiChatApp.createAiAttachmentFilesStatus;
};
export var selectCreateAiAttachmentFilesOutput = function selectCreateAiAttachmentFilesOutput(rootState) {
  return rootState.aiChatApp.createAiAttachmentFilesOutput;
};
export var selectValidatePublicFileUrlStatus = function selectValidatePublicFileUrlStatus(rootState) {
  return rootState.aiChatApp.validatePublicFileUrlStatus;
};
export var selectValidatePublicFileUrlOutput = function selectValidatePublicFileUrlOutput(rootState) {
  return rootState.aiChatApp.validatePublicFileUrlOutput;
};
export var selectUploadConversationFilesStatus = function selectUploadConversationFilesStatus(rootState) {
  return rootState.aiChatApp.uploadConversationFilesStatus;
};
export var selectUploadConversationFilesOutput = function selectUploadConversationFilesOutput(rootState) {
  return rootState.aiChatApp.uploadConversationFilesOutput;
};
export var selectPromptTemplatesStatus = function selectPromptTemplatesStatus(rootState) {
  return rootState.aiChatApp.promptTemplatesStatus;
};
export var selectPromptTemplates = function selectPromptTemplates(rootState) {
  return rootState.aiChatApp.promptTemplates;
};
export var selectLlmProvidersStatus = function selectLlmProvidersStatus(rootState) {
  return rootState.aiChatApp.llmProvidersStatus;
};
export var selectLlmProviders = function selectLlmProviders(rootState) {
  return rootState.aiChatApp.llmProviders;
};
export var selectUsageWalletStatus = function selectUsageWalletStatus(rootState) {
  return rootState.aiChatApp.usageWalletStatus;
};
export var selectUsageWallet = function selectUsageWallet(rootState) {
  return rootState.aiChatApp.usageWallet;
};
export var selectAccountingSubscriptionStatus = function selectAccountingSubscriptionStatus(rootState) {
  return rootState.aiChatApp.accountingSubscriptionStatus;
};
export var selectAccountingSubscription = function selectAccountingSubscription(rootState) {
  return rootState.aiChatApp.accountingSubscription;
};